
export default function permission( state = [], action = {} ){

	switch( action.type ){
		case 'GET_PERMISSION_USERS':
			return action.permission
		case 'UPDATE_PERMISSION_USERS':
			return action.permission
		default: return state;
	}
		
}




// WEBPACK FOOTER //
// ./src/store/reducers/permission/permission.reducer.js